/**
 * CLEAN OBJECT
 * When send an object to dynamo DB you have to take care that each value is not empty null.
 * It may caus errors on the backend side.
 * This function parse your object and delete empty, null, undefined values
 */

export default {
  methods: {
    cleanObject: function (dataToSend) {
      const cleanedObj = Object.assign({}, dataToSend);
      const entries = Object.entries(cleanedObj);
      for (const [k, v] of entries) {
        if( v === undefined || v === null || v === "" || (Array.isArray(v) && v.length === 0) ) {
          delete cleanedObj[k];
        }
      }
      return cleanedObj;
    }
  }
}